module.exports = __webpack_public_path__ + "static/media/default-community-category-3.856cce51.jpg";